import PropTypes from 'prop-types';
import React from 'react';
import 'client/styles/panelList.scss';

const propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  style: PropTypes.object,
};

const defaultProps = {
  style: null,
};

class PanelList extends React.PureComponent {
  render() {
    const {
      children,
      style,
    } = this.props;
    return (
      <ul
        className="panel-list"
        style={style}>
        { children }
      </ul>
    );
  }
}

PanelList.propTypes = propTypes;
PanelList.defaultProps = defaultProps;
export default PanelList;
